import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import IniciarSesion from '../components/templates/iniciarSesion';
import { sesionActions } from '../../application/actions/sesion';
import { workflowActionsSaga } from '../../infrastructure/services/workFlow';
import { actionsActionsSaga } from '../../infrastructure/services/acciones';
import { globalDataActionsSaga } from '../../infrastructure/services/globaldata';
import { roleActionsSaga } from '../../infrastructure/services/role';
import AppBarApp from '../components/organismos/AppBarApp';
import ClientsTemplate from '../components/templates/clients'
import UsersTemplate from '../components/templates/users'
import { clientActionsSaga } from '../../infrastructure/services/client';
import TrackingCase from '../components/templates/trackingCase'
import WebSocketComponent from '../components/organismos/wss/ws';


const App = () => {
  const dispatch = useDispatch();
  const [lassMessageAplication, setLassMessageAplication] = useState();
  const TOKEN = useSelector((store) => store.tk.sesion.token);

  const validaSesionExistente = async () => {
    var token = await sessionStorage.getItem('token');
    var user = await JSON.parse(sessionStorage.getItem('user'));
    TOKEN === null && token !== null && user !== null && dispatch(sesionActions.craerSesion({ token, user }));
  }
  validaSesionExistente();

  useEffect(() => {
    TOKEN && dispatch(workflowActionsSaga.activitiesGetAll())
    TOKEN && dispatch(actionsActionsSaga.actionsGetAll());
    TOKEN && dispatch(workflowActionsSaga.statesGetAll());
    TOKEN && dispatch(globalDataActionsSaga.getAllCourt());
    TOKEN && dispatch(globalDataActionsSaga.getAllLocation());
    TOKEN && dispatch(roleActionsSaga.getAll())
    TOKEN && dispatch(clientActionsSaga.getAll())
  }, [TOKEN]); 

  const recibedMessage = (message) => {
    console.log(message)
    setLassMessageAplication(message)
    setTimeout(() => { setLassMessageAplication() }, 2000)
  }


  return (
    <>
      <BrowserRouter>
        <Switch>
          {TOKEN === null ? (
            <>
              <Route exact path='/'>
                <IniciarSesion />
              </Route>
              <Route exact path="/recoverPassword">
                <IniciarSesion recovery />
              </Route>
            </>

          ) : (
            <>
              <AppBarApp lassMessageAplication={lassMessageAplication} />
              <Route exact path='/actives'>
                <TrackingCase estado={1} lassMessageAplication={lassMessageAplication} />
              </Route>
              <Route exact path='/save'>
                <TrackingCase estado={3} />
              </Route>
              <Route exact path='/clients'>
                <ClientsTemplate />
              </Route>
              <Route exact path='/users'>
                <UsersTemplate />
              </Route>
              <Route exact path='/home'>

              </Route>
              <Route exact path='/'>

              </Route>
              <WebSocketComponent callbackMessage={recibedMessage} />
            </>
          )}
        </Switch>
      </BrowserRouter>
    </>
  );
};

export default App;
